'use strict';
var _ = require('lodash');
var parsers = require('./parsers');

function parse (obj, schema) {
  var result = {};

  _.each(_.keys(schema), function (key) {
    var baseType = _.get(schema[key], 'baseType') || 'default';
    var baseTypeErrorMessage = _.get(schema[key], 'baseTypeErrorMessage');
    var value = _.get(obj, key);
    if (_.isFunction(parsers[baseType])) {
      result[key] = parsers[baseType](value, baseTypeErrorMessage);
    }
  });

  return result;
};

module.exports = parse;
